import useTranslation from "@babackapp/translations/use-translation";
import { toast } from "@babackapp/ui/components/sonner";
import FormToast from "./form-toast";

type NotificationContent = {
  title?: string;
  message?: string;
};

export function useFormSuccessNotification(content?: NotificationContent) {
  const t = useTranslation();
  return () => {
    const title =
      content?.title || t("formNotifications.success.title");
    const message = "";
    toast.custom((id) => (
      <FormToast title={title} message={message} toastId={id} type="success" />
    ));
  };
}

export function useFormErrorNotification(content?: NotificationContent) {
  const t = useTranslation();
  return () => {
    const title = content?.title || t("formNotifications.error.title");
    const message = content?.message || t("formNotifications.error.message");
    toast.custom((id) => (
      <FormToast title={title} message={message} toastId={id} type="error" />
    ));
  };
}

export function useFormErrorNotif() {
  const t = useTranslation();
  return (content?: NotificationContent) => {
    const title = content?.title || t("formNotifications.error.title");
    const message = content?.message || t("formNotifications.error.message");
    toast.custom((id) => (
      <FormToast title={title} message={message} toastId={id} type="error" />
    ));
  };
}

export function useFormSuccessNotif() {
  const t = useTranslation();
  return (content?: NotificationContent) => {
    const title = content?.title || t("formNotifications.success.title");
    const message = content?.message || t("formNotifications.success.message");
    toast.custom((id) => (
      <FormToast title={title} message={message} toastId={id} type="success" />
    ));
  };
}
